import { type HgSupportedLanguage } from '@smg-real-estate/domus';
import {
  getHgCoreLinkAttributes,
  getHgCoreMetaProperties,
  getIs24CoreLinkAttributes,
  getIs24CoreMetaProperties,
} from '@smg-real-estate/metatags-seo';
import type { Link, Meta } from '@unhead/vue';

import { isPlatformIs24 } from '@/helpers/platform';

import { localizeLanguage } from './localizeLanguage';

export const getAppMetaInfo = (
  locale: HgSupportedLanguage,
): {
  htmlAttrs: {
    lang: string;
  };
  meta: Meta[];
  link: Link[];
} => ({
  htmlAttrs: {
    lang: localizeLanguage(locale),
  },
  meta: (isPlatformIs24()
    ? getIs24CoreMetaProperties()
    : getHgCoreMetaProperties()) as unknown as Meta[],
  link: (isPlatformIs24()
    ? getIs24CoreLinkAttributes()
    : getHgCoreLinkAttributes()) as unknown as Link[],
});
